<template>
  <div>
    <button class="text-blue-500 font-semibold" @click="openModal = true">Distribution Center QR Code</button>
    <LayoutDisasterPantryQrModal v-if="openModal" :open="openModal" @close="openModal = false" />
  </div>
</template>
<script setup lang="ts">
const openModal = ref(false);
</script>
